import React from 'react';
import PropTypes from 'prop-types';
import DetailsCell from './details_cell';
import { componentText } from '../../utils/i18n_utils';

const ParRow = ({ tee }) => {
  const nrHoles = tee.holeData.par.length;
  return (
    <tr className="lbv2__par-row">
      <DetailsCell className="lbv2__par text sticky">{componentText('details_table.par', 'Par')}</DetailsCell>
      {tee.holeData.par.map((par, index) => (
        <React.Fragment key={index}>
          <DetailsCell className="lbv2__par">{par}</DetailsCell>
          {index === 8 && nrHoles === 18 && <DetailsCell className="lbv2__par">{tee.parSumFront}</DetailsCell>}
          {index === 17 && nrHoles === 18 && <DetailsCell className="lbv2__par sum-back">{tee.parSumBack}</DetailsCell>}
          {index === (nrHoles - 1) && <DetailsCell className="lbv2__par total">{tee.par}</DetailsCell>}
        </React.Fragment>
      ))}
    </tr>
  );
};

ParRow.propTypes = {
  tee: PropTypes.object.isRequired,
};

export default ParRow;
